import GroupedNestedTable from "../components/GroupedNestedTable";
import "../styles/NestedTable.scss";

const sampleData = [
  {
    resourceName: "Mitesh",
    Projects: [
      { name: "EDO", productive: 7, indirect: 0 },
      { name: "TMS", productive: 3, indirect: 1 }
    ]
  },
  {
    resourceName: "user1",
    Projects: [
      { name: "EDO", productive: 5, indirect: 2 },
      { name: "TMS", productive: 4, indirect: 0 },
      { name: "TMS1", productive: 4, indirect: 0 }

    ]
  },
];
// const sampleData1 = [
//   {
//     resourceName: "Mitesh",
//     Projects: [
//       { name: "EDO", task: 7, indirect: 0 },
//       { name: "TMS", task: 3, indirect: 1 }
//     ]
//   },
//   {
//     resourceName: "user1",
//     Projects: [
//       { name: "EDO", task: 5, indirect: 2 },
//       { name: "TMS", task: 4, indirect: 0 }
//     ]
//   },
// ];

  const NestedTableTestPage = () => {

    return (
        // eslint-disable-next-line react/jsx-no-comment-textnodes
        <div>
            <h1></h1>
            <GroupedNestedTable  data={sampleData } />
        </div>
    );
  };
  
  export default NestedTableTestPage;